export const colors = {
  primary: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
  },
  secondary: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
  },
  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  status: {
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#06b6d4',
  },
};

export const typography = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  h1: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  bodyLarge: {
    fontSize: '1.125rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },
  bodyRegular: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  bodySmall: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  bodyXs: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.4,
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.4,
  },
};

export const spacing = {
  xs: '0.25rem', // 4px
  sm: '0.5rem',  // 8px
  md: '1rem',    // 16px
  lg: '1.5rem',  // 24px
  xl: '2rem',    // 32px
  '2xl': '3rem', // 48px
  '3xl': '4rem', // 64px
};

export const breakpoints = {
  mobile: '640px',
  tablet: '1024px',
  desktop: '1536px',
};

export const shadows = {
  sm: '0 1px 3px rgba(0,0,0,0.05)',
  md: '0 4px 12px rgba(0,0,0,0.08)',
  lg: '0 8px 20px rgba(0,0,0,0.08)',
  card: '0 1px 3px rgba(0,0,0,0.05)',
  cardHover: '0 8px 20px rgba(0,0,0,0.08)',
  button: '0 4px 12px rgba(34,197,94,0.3)',
};

export const gradients = {
  production: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
  efficiency: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  temperature: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)',
  pressure: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  primary: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
};

export const borderRadius = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  card: '12px',
  button: '8px',
};

export const layout = {
  sidebar: {
    width: '240px',
    background: '#1e293b',
  },
  topBar: {
    height: '64px',
    background: '#ffffff',
  },
  contentPadding: '24px',
  contentGap: '24px',
};
